import guideImage from '../../../../../../../../assets/png/shopifyCrossCheckGuide.png';

export const GUIDE_TITLE = 'How to cross check Klickly driven orders in Shopify?';
export const GUIDE_IMAGE_SRC = guideImage;
export const GUIDELINE_MODAL_TOP = 149;
export const GUIDELINE_MODAL_WRAP_CLASS = 'tracking-shopify-guide-modal-wrap';
